import * as lib from '../api/cases.js';
import { fetchLoadable } from '../fetchLoadable.js';
import * as socket from '../socket.js';
import store from '../store.js';
import * as actionTypes from './actionTypes.js';
export const getById = (id, casualConsistency) => {
    const selectedOwners = store.getState().selectedOwners;
    const tenantId = selectedOwners[0];
    return fetchLoadable(actionTypes.FETCH_CASE_BY_ID, lib.getById, { id, casualConsistency }, false, () => {
        // @ts-ignore
        if (tenantId)
            socket.caseLoaded(tenantId, id);
    });
};
export const moveStatus = (id, status) => {
    // @ts-ignore
    return lib.patch(id, { status }).then(() => getById(id));
};
export const recognize = lib.recognize;
//# sourceMappingURL=actions.js.map